import { toast } from '@cashfree-intl/coherent';

// Utils
import request from 'utils/request';

// Constants //
import { DOWNLOAD_DOCUMENT_URL } from 'constants/url';

// Types
import { DownloadDocPayload } from './types';

export async function downloadDoc({
  queryString,
}: DownloadDocPayload): Promise<{ docUrl?: string }> {
  try {
    const { url, method } = DOWNLOAD_DOCUMENT_URL;
    const options = {
      method,
      queryString,
    };
    const response: { docUrl: string } = await request(url, options);
    return response;
  } catch (err) {
    toast.error(err.errorMeta.message);
    return {};
  }
}
